export default "__VITE_ASSET__Dcc1VIqP__"